import { render, staticRenderFns } from "./childrenConfig.vue?vue&type=template&id=bf35eb86&scoped=true&"
import script from "./childrenConfig.vue?vue&type=script&lang=js&"
export * from "./childrenConfig.vue?vue&type=script&lang=js&"
import style0 from "./childrenConfig.vue?vue&type=style&index=0&id=bf35eb86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf35eb86",
  null
  
)

export default component.exports